export default __webpack_public_path__ + "static/media/AirbnbCerealBlack.1b848ef9.woff";